var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import { white } from '../../Styles/Colours';
import { Button } from '../Button';
import { LoadingErrorIcon, ReloadIcon } from '../Icons';
import NoMedications from '../../Images/noMedications.svg';
import styles from './LoadingError.module.css';
export var LoadingError = function (_a) {
    var message = _a.message, info = _a.info;
    var _b = __read(useState(false), 2), isResidentListUrl = _b[0], setIsResidentListUrl = _b[1];
    useEffect(function () {
        var url = new URL(window.location.href);
        var isResidentList = url.pathname === '/residents' && !url.search && !url.hash;
        setIsResidentListUrl(isResidentList);
    }, []);
    var reload = function () {
        window.location.reload();
    };
    return (React.createElement("div", { className: isResidentListUrl ? styles.residentPageContainer : styles.container },
        !isResidentListUrl ? React.createElement(LoadingErrorIcon, null) : React.createElement("img", { src: NoMedications, alt: 'No Pateint found' }),
        isResidentListUrl ? (React.createElement("div", { className: styles.bodyText }, message || 'Refine your search to get better results')) : (React.createElement("div", { className: styles.bodyText }, message || "Whoop's... we've run into an error")),
        isResidentListUrl ? (React.createElement("div", { className: styles.infoContainer },
            React.createElement("div", { className: styles.info }, info || "We're experiencing high traffic right now. To keep things running smoothly,"),
            React.createElement("div", { className: styles.info }, info || 'please try refining your search or using more specific filters in the filter'),
            React.createElement("div", { className: styles.info }, info || 'panel on the left. Thanks for your patience!'))) : (React.createElement("div", { className: styles.infoNotResident }, info || 'Please reloading the page to try fetch the data you need.')),
        !isResidentListUrl && (React.createElement(Button, { testId: 'error-action', onClick: reload, startIcon: React.createElement(ReloadIcon, { color: white, size: '24', noPadding: true }) }, "Reload"))));
};
